import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'


const PermissoesComponent = ({  showMsg }) => {

    return (
        <>
              {(showMsg)?(
                <div className='alert alert-danger'>
                 <FontAwesomeIcon icon={faExclamationCircle}/>       Você não possui permissão para esta ação!
                </div>
              ):''}
          
        </>
    )
}

export default PermissoesComponent;